import React from "react";

import Grid from "@material-ui/core/Grid";

const Layout: React.FC = ({ children }) => (
  <Grid container={true} justify={"center"}>
    <Grid item={true} xs={"auto"}>
      {children}
    </Grid>
  </Grid>
);

export { Layout };
